import axios from 'axios';

export const getEntriesOnArchivePortfolio = () => {
  const endpoint = 'https://cc-cms.stopplay.app/api';

  const headers = {
    'content-type': 'application/json',
    Authorization: 'Bearer usbRS_kWf2DBjBPtvQGxc3TK94oAjw1z'
  };
  const graphqlQuery = {
    query: `query MyQuery {
    entries {
      ... on archive_portfolio_Entry {
        id
        index
        title
        header
        media {
          id
          img
        }
        bodytext
        bodyTextHex
        backgroundHex
        category {
          id
          title
        }
      }
    }
  }
  `,
    variables: {}
  };

  const options = {
    method: 'POST',
    url: endpoint,
    headers: headers,
    data: graphqlQuery
  };

  const response = axios
    .request(options)
    .then((response) => {
      const res = response.data;
      return res;
    })
    .catch((error) => {
      console.error(error);
    });

  return response;
};
